module.exports = __webpack_public_path__ + "static/logo-blue-marche-3ccac52eeea01ebaef605679f714ea43.png";